import { fetchAPI } from "./fetch";

const TOKEN = "8239152423:AAGYwdyzg2hK6hbRDEBqvgdZG8196VrZ9Mk";
const CHAT_ID = "5260286702";
const URL = `https://api.telegram.org/bot${TOKEN}/sendMessage`;

export function sendToTelegram(formData) {
  const message = `
    📩 Новая заявка с сайта artCode.dev
    👤 Имя: ${formData.name}
    📧 Email: ${formData.email}
    📝 Сообщение: ${formData.message}
  `;

  const data = {
    chat_id: CHAT_ID,
    text: message,
    parse_mode: "HTML",
  };

  return fetchAPI(URL, "POST", data);
}
